import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './DriverInformation.module.scss'
import { emailAddressAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const EmailAddress = ({ t, emailAddressValid, validateEmailAddress, emailAddressError, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const emailAddress = useSelector((state) => state.driver.driverInformation.emailAddress)

  const handleEmail = (e) => {
    try {
      let email = e.currentTarget.value.replace(/\s/g, '')
      dispatch(emailAddressAction(email))
      validateEmailAddress(email)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleOnBlur = () => {
    SetIsFocussed(false)
    validateEmailAddress(emailAddress)
  }

  return (
    <React.Fragment>
      <div className={styles['fields_margin']}>
        <div
          className={
            emailAddressValid === true
              ? emailAddress === ''
                ? ''
                : 'form-group has-success'
              : emailAddressValid === false
                ? 'form-group has-error'
                : ''
          }
        >
          <label className="control-label" htmlFor="EmailAddress">
            {t('driver_information.email_address')}
          </label>
          <div className="help-field">
            {t('driver_information.your_receipt_will_be')}
            <br />
            {t('driver_information.you_will_need_this')}{' '}
          </div>
          <input
            type="text"
            id="EmailAddress"
            className="form-control"
            onBlur={handleOnBlur}
            onFocus={() => SetIsFocussed(true)}
            value={emailAddress}
            onChange={handleEmail}
            autoComplete="off"
            maxLength="50"
          />
          {emailAddressValid === true ? (
            emailAddress === '' ? (
              ''
            ) : (
              <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            )
          ) : emailAddressValid === false ? (
            <React.Fragment>
              <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
              <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(emailAddressError)}</div>
            </React.Fragment>
          ) : (
            ''
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(EmailAddress)
